module.exports = __webpack_public_path__ + "img/doble1.3fbd4248.jpg";